import { BLACKLISTED_COMPANIES_FOR_JUNE_SO } from "@stadium/services/analytics/constants/blacklisted-companies";

export const getIsUserBlacklisted = ({ companyName }) =>
  BLACKLISTED_COMPANIES_FOR_JUNE_SO.includes(companyName?.toLowerCase());
